<template>
  <div>
    <p
      class="mb-4"
      style="font-size: 0.85rem; margin-left: 16px; font-weight: light !important"
      :style="template.secondaryTheme ? 'color: white;' : ''"
    >
      Buscar responsável pelo CPF ou E-mail.
    </p>

    <div class="col form-group mb-5">
      <input
        ref="searchInput"
        id="searchInput"
        v-model="searchValue"
        v-mask="cpfMask"
        class="w-100 c-input"
        :placeholder="$t('searchUser.cpfOrEmail')"
        type="text"
        @keyup.enter="handleSearch"
        @input="handleInputChange"
      />
    </div>

    <div class="col form-group mb-2 mt-3">
      <input
        :value="searchResult ? searchResult.name : ''"
        class="w-100 c-input"
        style="opacity: 0.5"
        type="text"
        readonly
        disabled
        :placeholder="$t('searchUser.guardianName')"
      />
    </div>

    <div class="col form-group mt-4">
      <button
        class="btn btn-block text-uppercase shadow-sm btnStock btn"
        :style="template.secondaryTheme ? secondaryBtnStyleTheme : secondaryBtnStyle"
        type="button"
        :disabled="!canSearch"
        @click="handleSearch"
      >
        Pesquisar
      </button>
    </div>

    <div v-if="isLoading" class="col form-group mt-4 text-center">
      <p :style="template.secondaryTheme ? 'color: white;' : ''">Pesquisando...</p>
    </div>

    <div v-if="errorMessage" class="col form-group mt-3">
      <p
        style="font-size: 0.85rem; color: #ff637e"
        :style="template.secondaryTheme ? 'color: #ff637e;' : ''"
      >
        {{ errorMessage }}
      </p>
    </div>

    <b-modal
      id="search-user-invalid-account-modal"
      v-model="showInvalidAccountModal"
      centered
      hide-header-close
      hide-footer
      :no-close-on-backdrop="false"
      :no-close-on-esc="true"
      :header-class="'border-0'"
      :content-class="'search-user-modal-content'"
      :style="'--modal-bg-color: ' + (template.secondaryColor || '#ffffff')"
    >
      <template #modal-header>
        <p
          class="modal-title w-100 text-center mb-4"
          style="font-size: 1.4rem; font-weight: 600;"
          :style="{ color: template.primaryColor }"
        >
          OPS, CONTA NÃO ENCONTRADA!
        </p>
      </template>

      <p class="mb-4 text-center" style="font-size: 0.9rem;" :style="{ color: template.primaryColor }">
        Não identificamos uma conta vinculada ao CPF informado.<br class="hidden lg:block"> Confira o número digitado ou cadastre um responsável.
      </p>
      <p class="mb-5 text-center" style="font-size: 1.2rem; font-weight: 500;" :style="{ color: template.primaryColor }">
        {{ displayCpfInAlert }}
      </p>

      <div class="d-flex flex-column align-items-center mt-4 px-4" style="gap: 6px;">
        <button
          type="button"
          class="btn btn-block text-uppercase shadow-sm"
          style="font-size: 1.1rem; padding: 10px 12px; font-weight: 500;"
          :style="primaryBtnStyle"
          @click="onInvalidAccountTryAgain"
        >
          Tentar novamente
        </button>
        <button
          type="button"
          class="btn btn-block text-uppercase shadow-sm"
          style="border: 1.5px solid; font-size: 1.1rem; padding: 10px 16px; font-weight: 500; margin-bottom: 3rem;"
          :style="{
            color: template.primaryColor,
            borderColor: template.primaryColor,
            backgroundColor: 'transparent',
          }"
          @click="onInvalidAccountRegisterGuardian"
        >
          Cadastrar responsável
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { mask } from 'vue-the-mask'
import { loginFB } from '../../services/ServFB.js'

const lFB = new loginFB()

export default {
  name: 'SearchUser',
  props: {
    validate: {
      type: Boolean,
      required: true,
    },
  },
  mask: {
    ...mask,
    tokens: {
      ...mask.tokens,
      null: /./,
    },
  },
  data: () => ({
    obj: {},
    searchValue: '',
    isLoading: false,
    searchResult: null,
    errorMessage: '',
    cpfMask: null,
    toastMessage: '',
    showInvalidAccountModal: false,
    invalidAccountMessage: '',
    displayCpfInAlert: '',
    blockAdvanceAfterInvalidAccount: false,
  }),
  computed: {
    ...mapGetters(['primaryBtnStyle', 'secondaryBtnStyle', 'secondaryBtnStyleTheme']),
    ...mapState(['template', 'registrationObject', 'config']),
    clientId() {
      const route = this.$route
      const fromUrl = route && route.query && (route.query.client_id || route.query.clientId)
      if (fromUrl) return fromUrl
      const config = this.config
      if (!config) return ''
      if (config.sso && config.sso.clientId) return config.sso.clientId
      return config.name || ''
    },
    canSearch() {
      if (!this.searchValue || !this.searchValue.trim()) {
        return false
      }
      const trimmedValue = this.searchValue.trim()
      const isCPF =
        /^[\d.\- ]+$/.test(trimmedValue) && trimmedValue.replace(/[^\d]/g, '').length >= 11
      const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedValue)
      return isCPF || isEmail
    },
  },
  watch: {
    validate(newValue) {
      if (newValue) this.validateFields()
    },
    searchValue(newValue) {
      const trimmedValue = newValue.trim()
      const isEmail = /@/.test(trimmedValue)

      if (isEmail) {
        this.cpfMask = null
      } else {
        const cleanValue = trimmedValue.replace(/[^\d]/g, '')
        if (cleanValue.length <= 11 && /^\d+$/.test(cleanValue)) {
          this.cpfMask = '###.###.###-##'
        } else {
          this.cpfMask = null
        }
      }
    },
  },
  created() {
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))
  },
  mounted() {
    if (this.$refs.searchInput) {
      this.$refs.searchInput.focus()
    }
  },
  methods: {
    ...mapMutations([
      'updateRegistrationObject',
      'clearRegistrationErrors',
      'addRegistrationError',
    ]),
    handleInputChange() {
      this.errorMessage = ''
      this.searchResult = null
    },
    async handleSearch() {
      if (!this.canSearch) {
        return
      }

      const cpfDigits = this.searchValue.replace(/\D/g, '')
      if (cpfDigits.length !== 11) {
        this.errorMessage = 'Para buscar responsável, informe o CPF (11 dígitos).'
        this.toastMessage = this.errorMessage
        this.makeToast('warning')
        return
      }

      this.isLoading = true
      this.errorMessage = ''
      this.searchResult = null

      try {
        await this.checkGuardianApi()
      } catch (error) {
        this.errorMessage =
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.header &&
            error.response.data.header.msg) ||
          'Erro ao pesquisar. Tente novamente.'
        this.toastMessage = this.errorMessage
        this.makeToast('danger')
      } finally {
        this.isLoading = false
      }
    },
    async validateFields() {
      this.$emit('validating')
      this.clearRegistrationErrors()
      let hasErrors = false

      if (!this.searchValue || !this.searchValue.trim()) {
        hasErrors = true
        const warningMsg = 'É necessário informar um responsavel.'
        this.addRegistrationError({ msg: warningMsg })
        this.toastMessage = warningMsg
        this.makeToast('warning')
      } else if (!this.canSearch) {
        hasErrors = true
        const warningMsg = 'Por favor, informe um CPF válido (11 dígitos) ou um E-mail válido.'
        this.addRegistrationError({ msg: warningMsg })
        this.toastMessage = warningMsg
        this.makeToast('warning')
      }

      const cpfDigits = this.searchValue.replace(/\D/g, '')
      if (!hasErrors && cpfDigits.length !== 11) {
        hasErrors = true
        const warningMsg = 'Para buscar responsável, informe o CPF (11 dígitos).'
        this.addRegistrationError({ msg: warningMsg })
        this.toastMessage = warningMsg
        this.makeToast('warning')
      }

      if (!hasErrors) {
        if (!this.searchResult) {
          this.isLoading = true
          try {
            await this.checkGuardianApi()
          } catch (error) {
            hasErrors = true
            this.errorMessage =
              (error &&
                error.response &&
                error.response.data &&
                error.response.data.header &&
                error.response.data.header.msg) ||
              'Erro ao pesquisar. Tente novamente.'
            this.toastMessage = this.errorMessage
            this.addRegistrationError({ msg: this.errorMessage })
            this.makeToast('danger')
          } finally {
            this.isLoading = false
          }
          if (!hasErrors && this.blockAdvanceAfterInvalidAccount) {
            hasErrors = true
          }
          if (!hasErrors && this.errorMessage && !this.searchResult) {
            hasErrors = true
            this.addRegistrationError({ msg: this.errorMessage })
          }
        }

        if (this.searchResult && !hasErrors) {
          let identityNumber =
            typeof this.searchResult.identity === 'string'
              ? parseInt(this.searchResult.identity.replace(/[^\d]/g, ''), 10)
              : parseInt(this.searchResult.identity, 10)

          if (Number.isNaN(identityNumber) || identityNumber <= 0) {
            hasErrors = true
            this.errorMessage = 'Erro: Identidade inválida retornada pela pesquisa.'
            this.toastMessage = this.errorMessage
            this.addRegistrationError({ msg: this.errorMessage })
            this.makeToast('danger')
            return
          }

          this.obj.searchIdentity = {
            identity: 0,
            numberType: 14,
            number: String(identityNumber),
            verified: null,
          }

          this.obj.searchResultName = this.searchResult.name

          this.$store.commit('updateRegistrationObject', this.obj)
          this.$emit('next', { guardianResolvedViaSearch: true })
        }
      }
    },
    async checkGuardianApi() {
      const number = this.searchValue.replace(/\D/g, '')
      const ownerId = parseInt(this.config && this.config.ownerId, 10)
      const systemId = parseInt(this.config && this.config.systemID, 10)

      if (!number || number.length !== 11 || !ownerId || !systemId || !this.clientId) {
        const msg = 'Configuração incompleta (ownerId, systemId ou clientId).'
        this.errorMessage = msg
        throw new Error(msg)
      }

      const payload = {
        number,
        numberType: 1,
        ownerId,
        clientId: this.clientId,
        systemId,
      }

      const response = await lFB.checkGuardian(payload)

      if (!response || !response.header || response.header.codigo !== 1) {
        this.errorMessage =
          (response && response.header && response.header.msg) || 'Erro ao consultar responsável.'
        throw new Error(this.errorMessage)
      }

      const { action, actionData } = response.data || {}

      if (action === 'Success' && actionData && actionData.identity) {
        this.searchResult = {
          name: actionData.name || '',
          identity: actionData.identity,
        }
        this.errorMessage = ''
        this.blockAdvanceAfterInvalidAccount = false
        this.$emit('search-result', this.searchResult)
        return
      }

      if (action === 'InvalidAccount') {
        this.searchResult = null
        this.errorMessage = ''
        this.invalidAccountMessage =
          (actionData && actionData.message) || 'Não foi possível localizar o responsável.'
        this.displayCpfInAlert = this.searchValue.trim()
        this.blockAdvanceAfterInvalidAccount = true
        this.showInvalidAccountModal = true
        return
      }

      this.searchResult = null
      this.blockAdvanceAfterInvalidAccount = false
      this.errorMessage =
        (actionData && actionData.message) || 'Não foi possível localizar o responsável.'
      this.toastMessage = this.errorMessage
      this.makeToast('warning')
    },
    onInvalidAccountTryAgain() {
      this.showInvalidAccountModal = false
      this.blockAdvanceAfterInvalidAccount = false
      this.clearRegistrationErrors()
      this.$nextTick(() => {
        if (this.$refs.searchInput) {
          this.$refs.searchInput.focus()
        }
      })
    },
    onInvalidAccountRegisterGuardian() {
      this.showInvalidAccountModal = false
      this.blockAdvanceAfterInvalidAccount = false
      this.clearRegistrationErrors()
      this.$emit('goto-guardian-from-search')
    },
    makeToast(variant = null) {
      this.$bvToast.toast(this.toastMessage || 'Erro ao pesquisar', {
        title: this.$t('common.attention'),
        variant: variant,
        solid: true,
      })
    },
  },
}
</script>

<style scoped>
.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>

<style>
.search-user-modal-content {
  background-color: var(--modal-bg-color, #ffffff) !important;
  border: none;
  border-radius: 12px;
}
.search-user-modal-content .modal-header,
.search-user-modal-content .modal-body,
.search-user-modal-content .modal-footer {
  background-color: transparent !important;
}
</style>
